import { IKogIcon } from "@/main/@types/interfaceIcons";

export function AwaitingReleaseIcon({ height = "50px", width = "50px", color = "currentColor" }: IKogIcon) {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 486.000000 442.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g transform="translate(0.000000,442.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
				<path
					d="M1228 4261 c-126 -40 -211 -118 -276 -250 -36 -74 -37 -79 -37 -186
          0 -106 1 -112 37 -185 86 -177 229 -270 412 -270 160 0 292 71 378 205 90 138
          102 297 34 438 -41 86 -109 166 -173 203 -107 64 -260 82 -375 45z m286 -145
          c69 -34 138 -110 160 -178 18 -56 21 -155 6 -208 -36 -129 -174 -230 -315
          -230 -141 0 -279 101 -315 230 -15 53 -12 154 6 207 18 54 68 120 117 155 91
          65 236 75 341 24z"
				/>
				<path
					d="M1064 3210 c-135 -35 -238 -103 -323 -214 -44 -57 -621 -1244 -621
          -1278 0 -18 45 -58 66 -58 7 0 24 10 37 23 14 12 151 282 313 617 276 569 292
          598 351 660 64 69 134 111 214 129 68 16 473 14 536 -3 85 -23 142 -57 206
          -126 58 -61 77 -96 282 -513 120 -246 222 -447 225 -447 3 1 22 28 42 61 l38
          60 -181 372 c-224 463 -237 486 -318 566 -77 77 -160 124 -267 151 -110 28
          -493 28 -600 0z"
				/>
				<path
					d="M3473 2440 c-260 -27 -524 -151 -708 -334 -228 -228 -345 -510 -345
          -836 0 -213 36 -365 131 -550 142 -277 387 -482 693 -579 135 -43 233 -55 411
          -48 169 6 272 30 424 96 457 199 738 682 691 1186 -27 282 -137 520 -335 721
          -134 136 -276 225 -453 284 -167 55 -345 76 -509 60z m331 -147 c268 -51 507
          -213 667 -450 100 -147 151 -290 170 -477 33 -309 -77 -614 -304 -841 -206
          -205 -456 -308 -747 -307 -407 2 -769 234 -946 606 -76 162 -88 221 -88 446 0
          184 2 200 28 285 54 176 143 324 277 457 250 247 591 349 943 281z"
				/>
				<path
					d="M3572 1979 c-12 -5 -27 -20 -32 -34 -6 -16 -10 -188 -10 -426 l0
          -400 25 -24 c29 -30 45 -31 79 -4 l26 20 0 413 c0 346 -2 415 -15 433 -18 25
          -43 33 -73 22z"
				/>
				<path
					d="M3532 854 c-41 -21 -62 -60 -62 -114 0 -55 22 -94 64 -114 117 -56
          226 52 178 176 -23 57 -117 84 -180 52z"
				/>
				<path
					d="M797 2292 c-16 -17 -17 -102 -17 -1018 0 -952 1 -1001 19 -1039 23
          -49 49 -77 104 -112 34 -22 57 -27 122 -31 73 -4 85 -1 135 25 67 36 114 95
          129 163 7 33 11 231 11 565 l0 514 26 20 c33 26 45 26 78 0 l26 -20 0 -514 c0
          -334 4 -532 11 -565 15 -68 62 -127 129 -163 50 -26 62 -29 135 -25 86 5 131
          25 187 84 61 65 58 9 58 1102 0 955 -1 1000 -18 1015 -24 22 -65 21 -85 -1
          -16 -17 -17 -99 -17 -976 0 -662 -3 -971 -11 -1001 -6 -24 -21 -52 -32 -63
          -46 -42 -135 -45 -179 -6 -47 43 -48 51 -48 597 0 534 -1 551 -43 611 -26 36
          -96 68 -152 68 -56 0 -126 -32 -152 -68 -42 -60 -43 -77 -43 -611 0 -546 -1
          -554 -48 -597 -44 -39 -133 -36 -179 6 -11 11 -26 39 -32 63 -8 30 -11 340
          -11 1003 0 916 -1 960 -18 975 -24 22 -65 21 -85 -1z"
				/>
			</g>
		</svg>
	);
}
